import Vue from 'vue'

const toSnakeCaseHandler = (el) => {
  el.target.value = el.target.value.replace(' ', '_').replace(/\W/, '').toLowerCase()
}

Vue.directive('snake-case', {
  bind: (el) => {
    const input = el.querySelectorAll("input")[0]
    input.addEventListener('input',toSnakeCaseHandler)
  },
  unbind: (el) => {
    const input = el.querySelectorAll("input")[0]
    input.removeEventListener('input', toSnakeCaseHandler)
  }
})